import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';
import { ClientContactStateClass } from './interfaces/ClientContactStateClass';
import fetchAPI from '../../../common/fetchAPI';
import { sortData } from '../../../common/timeLiveFunction';

const initialState: ClientContactStateClass = {
    isLoading: false,
    status: "idle",
    isReload: false,
    selectedRecord: {},
    clientContactList: [],
    sortOrder: 'asc',
    sortColumn: 'FirstName',
    search: '',
    pageNo: 1,
    pageSize: 10
}

interface IThunkApi {
    state: {
        clientContact: ClientContactStateClass
    }
}

export const getAccountEmployeeTypeAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "EmployeeTypes/v2/getAccountEmployeeType",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/EmployeeTypes", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }

    )

export const getClientContactsByAccountPartyIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientContacts/v2/getClientContactsByAccountPartyId",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/ClientContacts/" + arg, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const getAccountPartyContactsByAccountPartyIdAndAccountClientContactIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientContacts/v2/getAccountPartyContactsByAccountPartyIdAndAccountClientContactId",
        async (arg, thunkApi) => {
            const { AccountPartyContactId, AccountPartyId, ...argWithoutId } = arg;
            const response = await fetchAPI("api/v2/ClientContacts/PartyContactsById/" + AccountPartyContactId + "/" + AccountPartyId, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const addAccountClientContactAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientContacts/v2/addAccountClientContact",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/ClientContacts/", "POST", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const updateAccountClientContactAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientContacts/v2/updateAccountClientContact",
        async (arg, thunkApi) => {
            const { AccountPartyContactId, AccountExpenseTypeId, ...argWithoutId } = arg;
            const response = await fetchAPI("api/v2/ClientContacts/" + AccountPartyContactId, "PUT", argWithoutId, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const deleteAccountClientContactAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientContacts/v2/deleteAccountClientContact",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/ClientContacts/" + arg, "Delete", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const DeleteSelectedAccountClientContactAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientContacts/v2/DeleteSelectedAccountClientContact",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/ClientContacts/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )

export const clientContactSlice = createSlice({
    name: "clientContact",
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {}
        },
        checkedState: (state, action) => {
            const currentindex = state.clientContactList.findIndex((item) => item.AccountPartyContactId == action.payload);
            const newArray = [...state.clientContactList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.clientContactList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.clientContactList.findIndex((item) => item.AccountPartyContactId == action.payload);
            const newArray = [...state.clientContactList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.clientContactList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.clientContactList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.clientContactList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.clientContactList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.clientContactList = newArray;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.clientContactList;
            state.clientContactList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        },
        checkAllCheckboxIsUncheckedState: (state) => {
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountEmployeeTypeAsync.pending, (state) => {
                state.status = "loading";
                state.isLoading = true;
            })
            .addCase(getAccountEmployeeTypeAsync.fulfilled, (state, { payload }) => {

            })
            .addCase(getAccountEmployeeTypeAsync.rejected, (state) => {
                state.status = "failed";
            })
            .addCase(getClientContactsByAccountPartyIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getClientContactsByAccountPartyIdAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                if (Object.keys(payload.Data).length === 0) {
                    state.clientContactList = [];
                } else {
                    state.clientContactList = payload.Data;
                    state.clientContactList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getClientContactsByAccountPartyIdAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(getAccountPartyContactsByAccountPartyIdAndAccountClientContactIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountPartyContactsByAccountPartyIdAndAccountClientContactIdAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                if (Object.keys(payload.Data[0]).length === 0) {
                    state.selectedRecord = {};
                } else {
                    state.selectedRecord = payload.Data[0];
                }
                state.isReload = false;
                state.isLoading = false;
            })
            .addCase(getAccountPartyContactsByAccountPartyIdAndAccountClientContactIdAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(addAccountClientContactAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addAccountClientContactAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(addAccountClientContactAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(updateAccountClientContactAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateAccountClientContactAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(updateAccountClientContactAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(deleteAccountClientContactAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountClientContactAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAccountClientContactAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(DeleteSelectedAccountClientContactAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteSelectedAccountClientContactAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(DeleteSelectedAccountClientContactAsync.rejected, (state) => {
                state.status = 'failed';
            })
    }
})

export const {
    resetSelectedRecordObjectInState,
    checkedState,
    unCheckedState,
    checkedAllState,
    unCheckedAllState,
    checkAllCheckboxIsUncheckedState,
    updateSorting,
    updatePagination } = clientContactSlice.actions
// export const EmployeeTypeState = (state: RootState) => state.clientContact
export const clientContactState = (state: RootState) => state.clientContact
export default clientContactSlice.reducer


